import { useState, useEffect } from 'react';
import { Entry } from '../services/DataService';
import useLocalStorage from './useLocalStorage';

type ChecklistProps = (
    id: string,
    data: Entry[]
) => {
    data: Entry[];
    click: (id: number, selected: boolean) => void;
    reset: () => void;
};

type Selected = { [index: string]: null };

const useChecklist: ChecklistProps = (id, data) => {
    const { getItem, setItem } = useLocalStorage(id);
    const [stateData, setStateData] = useState(data);

    const [selectedList, setSelectedList] = useState<Selected>(
        (getItem() as Selected) || {}
    );

    useEffect(() => {
        setStateData((currentData) =>
            currentData.map((entry) => ({
                ...entry,
                selected: selectedList.hasOwnProperty(entry.id),
            }))
        );
        setItem(selectedList);
    }, [selectedList]);

    const click = (id: number, selected: boolean) => {
        if (selected) {
            setSelectedList((current) => ({ ...current, [id]: null }));
        } else {
            setSelectedList((current) => {
                const newSelected = { ...current };
                delete newSelected[id];
                return newSelected;
            });
        }
    };

    const reset = () => {
        setSelectedList({});
    };

    return {
        data: stateData,
        click,
        reset,
    };
};

export default useChecklist;
